<template>
  <footer id="contact">
    <div class="background"></div>
    <div class="contact_title">CONTACT US</div>
    <div class="container" style>
      <div class="row">
        <div class="item navigation">
          <a href="#gallery">GALLERY</a>
        </div>
        <div class="item navigation">/</div>
        <div class="item navigation">
          <a href="#menu">MENU</a>
        </div>
        <div class="item navigation">/</div>
        <div class="item navigation">
          <a href="#about">ABOUT US</a>
        </div>
        <div class="item navigation">/</div>
        <div class="item navigation">
          <a href="javascript:;">CONTACT US</a>
        </div>
      </div>

      <div class="visitors">NUMBER OF VISITORS</div>
      <div class="number">{{visit}}</div>

      <div class="row info">
        <div class="center info-item">
          <img class="info-icon center" src="../../../assets/img/footer/time.png" />
          <div class="center info-text">
            LUNCH BUFFET: 10:30am - 3:00pm
            <br />
            <br />DINNER BUFFET: 3:00pm - 9:00pm
            <br />
            <br />Mon-Sat：10：00am-07：30pm
          </div>
        </div>

        <div class="center info-item">
          <img class="info-icon center" src="../../../assets/img/footer/tel.png" />
          <div class="center info-text">Tel: 906 - 779 - 5588</div>
        </div>
        <div class="center info-item">
          <img class="info-icon center" src="../../../assets/img/footer/addr.png" />
          <div class="center info-text">
            1439 S. Stephenson Ave .
            <br />
            <br />Iron Mountaln, MI 49801
          </div>
        </div>
      </div>

      <div class="social center">
        <span>CONNECT WITH US</span>
        <a href>
          <img src="../../../assets/img/footer/facebook.png" />
        </a>
        <a href>
          <img src="../../../assets/img/footer/twiter.png" />
        </a>
        <a href>
          <img src="../../../assets/img/footer/ins.png" />
        </a>
      </div>
      <div class="center copyright">
        Copyright © 2020 - Designed By
        <a
          href="http://epayworld.us"
          target="_blank"
          rel="noopener noreferrer"
          style="text-decoration: underline;"
        >Epay Studio</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Contact",
  props: {},
  data() {
    return {
      visit: 200
    };
  },
  components: {},
  methods: {}
};
</script>

<style scoped lang="scss">
.center {
  text-align: center;
}

#contact {
  color: #ffffff;
  position: relative;
  padding-top: 2.424242rem;
  padding-bottom: 2.424242rem;

  @media (max-width: 799px) {
    padding-top: 1.515152rem;
    padding-bottom: 0.454545rem;
  }

  .background {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: url("../../../assets/img/footer/contact_back.jpg") no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    z-index: 0;
    /* Chrome, Safari, Opera */
  }

  .contact_title {
    font-family: "FZPWK";
    font-size: 0.969697rem;
    text-align: center;
    z-index: 999;
    position: relative;
    text-shadow: 0.121212rem 0.151515rem 0.060606rem #ffbe33;
    margin-bottom: 1.818182rem;

    @media (max-width: 799px) {
      font-size: 0.363636rem;
      text-shadow: 0.030303rem 0.030303rem 0.060606rem #ffbe33;
      margin-bottom: 0.666667rem;
    }
  }

  .text {
    font-family: "SourceHanSansCN Bold";
    font-size: 0.727273rem;

    position: relative;
    z-index: 999;
    li {
      display: inline;

      div {
        display: inline-block;
        margin-left: 1.515152rem;
        font-size: 0.909091rem;
        font-family: monospace;
        height: 1.515152rem;
        line-height: 1.515152rem;
      }
    }
  }

  .row {
    position: relative;
    z-index: 999;
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-flow: row wrap;

    .item {
      -webkit-box-flex: 1;
      flex: 1;
    }

    &.info {
      margin-top: 1.515152rem;
      font-size: 0.606061rem;
      margin-bottom: 1.515152rem;

      @media (max-width: 799px) {
        margin-top: 0.606061rem;
        margin-bottom: 0.606061rem;
      }
    }

    .info-item {
      -webkit-box-flex: 1;
      flex: 1;

      @media (max-width: 799px) {
        width: 50%;
        -webkit-box-flex: 1;
        flex: auto;

        &:last-of-type {
          margin-top: 0.606061rem;
        }
      }

      .info-icon {
        width: 1.818182rem;
        margin: 0 auto;

        @media (max-width: 799px) {
          width: 0.909091rem;
        }

        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }

      .info-text {
        margin-top: 2.121212rem;

        @media (max-width: 799px) {
          margin-top: 0.378788rem;
          font-size: 0.30303rem;
        }
      }
    }
  }

  .navigation {
    position: relative;
    z-index: 999;
    font-family: "SourceHanSansCN Bold";
    font-size: 0.848485rem;
    text-align: center;
    white-space: nowrap;
    @media (max-width: 799px) {
      font-size: 0.30303rem;
    }
  }

  .main-wrap {
    position: absolute;
    width: 13.969697rem;
    height: 8.69697rem;
    left: 24.909091rem;
    top: 8.909091rem;
    z-index: 999;
  }

  .visitors {
    font-family: "microsoft yahei";
    font-size: 0.727273rem;
    text-align: center;
    text-shadow: 0.090909rem 0.060606rem 0.060606rem #ffbe33;
    margin-top: 1.515152rem;
    position: relative;
    z-index: 999;
    @media (max-width: 799px) {
      font-size: 0.363636rem;
      margin-top: 0.69697rem;
    }
  }

  .number {
    font-family: impact;
    font-size: 0.969697rem;
    text-align: center;
    margin-top: 1.212121rem;
    letter-spacing: 0.30303rem;
    margin-bottom: 1.212121rem;
    position: relative;
    z-index: 999;
    @media (max-width: 799px) {
      font-size: 0.545455rem;
      margin-top: 17.5px;
      margin-bottom: 0.727273rem;
    }
  }

  .social {
    width: 20rem;
    margin: 0 auto;
    padding-top: 1.212121rem;
    font-size: 0.606061rem;
    position: relative;
    z-index: 999;
    @media (max-width: 799px) {
      font-size: 0.30303rem;
      width: 80%;
      padding-top: 0;
    }

    .connect {
      height: 1.818182rem;
      line-height: 1.818182rem;
      vertical-align: middle;
      font-size: 0.606061rem;
    }

    a {
      display: inline-block;

      img {
        vertical-align: middle;
        margin-left: 0.606061rem;
        width: 1.818182rem;

        @media (max-width: 799px) {
          width: 0.909091rem;
          margin-left: 0.363636rem;
        }
      }
    }
  }

  .copyright {
    font-family: "SourceHanSansCN Bold";
    font-size: 0.606061rem;
    margin-top: 1.515152rem;
    position: relative;
    z-index: 999;
    @media (max-width: 799px) {
      font-size: 0.242424rem;
      margin-top: 0.909091rem;
    }
  }
}
</style>
